export default __webpack_public_path__ + "static/media/chess.ca358477.obj";